<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user.avatar,
                'bg-green-500': user.status === 'online',
                'bg-amber-500': user.status === 'away',
                'bg-red-500': user.status === 'busy',
                'bg-gray-400': user.status === 'not-visible',
            }"
        ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="min-w-[320px]">
    <button mat-menu-item disabled>
        <span class="flex flex-col leading-none">
            <span>Conectado como</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <!-- ✅ Selector de emisor -->
    <div class="px-3 py-2" (click)="$event.stopPropagation()">
        <div class="text-xs font-medium text-secondary mb-2">
            Emisor
        </div>

        <mat-form-field class="fuse-mat-dense fuse-mat-rounded w-full" [subscriptSizing]="'dynamic'">
            <mat-icon matPrefix class="icon-size-5" [svgIcon]="'heroicons_solid:building-office-2'"></mat-icon>

            <mat-select
                [value]="selectedEmisorId"
                (selectionChange)="changeEmisor($event.value)"
                [disabled]="loadingEmisores || emisores.length === 0">

                <mat-option *ngFor="let e of emisores" [value]="e.id">
                    {{ e.rfc }} - {{ e.razonSocial }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="emisores.length === 0 && !loadingEmisores" class="text-xs text-secondary mt-1">
            No hay emisores activos.
        </div>

        <div *ngIf="loadingEmisores" class="text-xs text-secondary mt-1">
            Cargando emisores...
        </div>
    </div>

    <mat-divider class="my-2"></mat-divider>

    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Salir</span>
    </button>
</mat-menu>